import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ERROR, START } from 'shared/data/quoteSteps';
import { selectFabricationDataForActions } from 'taiwan_pcb/pcb_fabrication/slice/selectors';
import { doEmailQuote } from 'taiwan_pcb/pcb_fabrication/slice/thunks';
import toast from 'react-hot-toast';

import { alert } from 'shared/product_tabs/alert/alertSlice';
import QuoteAction from 'shared/components/QuoteAction';
import EmailQuoteModal from 'shared/components/EmailQuoteModal';

const QuoteActionBar = () => {
  const dispatch = useDispatch();
  const [showEmailQuoteModal, setShowEmailQuoteModal] = useState(false);
  const {
    quote,
    quoteStep,
    parametersChanged,
    parameters,
    productToCompare,
  } = useSelector(selectFabricationDataForActions);

  const onEmailQuote = () => {
    if (parametersChanged) {
      dispatch(alert({
        variant: 'danger',
        title: Spree.translations.parameters_have_changed_title,
        message: Spree.translations.parameters_have_changed,
      }));
    } else {
      setShowEmailQuoteModal(true);
    }
  };

  const dismissEmailQuoteModal = () => {
    setShowEmailQuoteModal(false);
  };

  const onSendEmailQuote = async (data) => {
    try {
      await dispatch(doEmailQuote({ data })).unwrap();
      toast(Spree.translations.email_quote_success, { type: 'success' });
    } catch (error) {
      toast(Spree.translations.email_quote_error, { type: 'error' });
    } finally {
      dismissEmailQuoteModal();
    }
  };

  const disabled = quoteStep === START || quoteStep === ERROR;

  return (
    <div className="quote-action-bar">
      <QuoteAction
        icon={Spree.image_assets.email_icon}
        label="Email Quote"
        onClick={onEmailQuote}
        disabled={disabled} />
      <EmailQuoteModal
        quote={quote}
        show={showEmailQuoteModal}
        onHide={dismissEmailQuoteModal}
        onSend={onSendEmailQuote}
        parameters={parameters}
        productToCompare={productToCompare} />
    </div>
  );
};

export default QuoteActionBar;
